import React, { useRef, useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { setStartTime, setEndTime, setScrollerObj, getPlaybackEvents } from '../../actions';
import VideoCard from './VideoCard'

const CardsContainer = props => {
  const scrollRef = useRef(null)
  const [scrollTimeout, setScrollTimeout] = useState(null)

  useEffect(() => {
    // we want this to run everytime the page loads, so both the timeline and event cards scroll based on the startTime
    props.setScrollerObj('')
  // eslint-disable-next-line
  }, [])

  useEffect(() => {
    // set the topmost card based on startTime if we are scrolling in the timeline side
    if (props.scrollerObj !== 'cards' && scrollRef.current) {
      let children = scrollRef.current.children
      let topChild = null

      for (let i = 0; i < children.length; i++) {
        // ts: 2024-01-10T17:01:15.000Z
        // compare the hours, once we get the very first card that is >= to timeline hour, then set it as topChild
        if (props.startTime && children[i].dataset.ts && parseInt(children[i].dataset.ts.substring(11,13)) >= parseInt(props.startTime.substring(0,2))) {
          topChild = children[i]
          break
        }
      }
      
      // event card's offsetTop is based from the top of the window, not on top of container
      topChild && scrollRef.current.scrollTo({top: (topChild.offsetTop - scrollRef.current.offsetTop), behavior: 'smooth'})
    }
  }, [props.startTime, props.scrollerObj])

  useEffect(() => {
    // check if container have event cards already
    if (props.selectedEvent && props.selectedEvent.bID && scrollRef.current.children && scrollRef.current.children.length > 1) {
      const eventCard = [...scrollRef.current.children].filter(c => parseInt(c.dataset.cardid) === props.selectedEvent.bID)
      eventCard[0] && eventCard[0].scrollIntoView({behavior: 'auto', block: 'center'})
    }
  }, [props.selectedEvent])

  const getEventCards = () => {
    let cards = []

    if (props.eventsLoading && props.events.length === 0) {
      // this is a new search
      cards.push(<div key={0} style={styles.message}>Loading...</div>)
    } else if (props.filteredEvents.length > 0) {
      // this is after a search and we have retrieved some events
      props.filteredEvents.forEach((ev, _) => {
        ev.bDuration > 1 && cards.push(<VideoCard key={ev.bID} event={ev} />)
      })
    } else if (props.searchFilters) {
      // this is after a search and there's no results
      cards.push(<div key={0} style={styles.message}>No events found using selected filters</div>)
    } else {
      // this is on initial display - nothing has been searched yet
      cards.push(<div key={0} style={styles.message}>No events</div>)
    }
    return cards
  }

  const handleScroll = () => {
    if (props.scrollerObj !== 'cards') return

    // scroll to the next nearest hour
    if (scrollTimeout !== null) {
      clearTimeout(scrollTimeout)
    }

    const timeout = setTimeout(async () => {
      // just get the time of the topmost card
      let children = scrollRef.current.children
      let scrollTop = scrollRef.current.scrollTop
      let topChild = null

      if (scrollTop === 0) {
        topChild = children[0]
      } else {
        for (let i = 0; i < children.length; i++) {
          // event card's offsetTop is based from the top of the window, not on top of container
          if ((children[i].offsetTop - scrollRef.current.offsetTop) >= scrollTop) {
            topChild = children[i]
            break
          }
        }
      }
      
      if (topChild) {
        const hour = topChild.dataset.ts && topChild.dataset.ts.substring(11, 13).padEnd(6, '0')
        props.setStartTime(hour)
        
        const lastEndTime = props.endTime
        let newEndTime = (parseInt(hour) + 40000).toString().padStart(6, '0') // + 4 hours
        newEndTime = parseInt(newEndTime) > 240000 ? '240000' : newEndTime // end time should not be more than midnight
        if (parseInt(newEndTime) > parseInt(lastEndTime)) {
          props.setEndTime(newEndTime)
          // we should only search events that we don't have yet, so that would be between the last end time, to the current end time
          await props.getPlaybackEvents(props.token, props.searchFilters.date, props.cameras, props.searchFilters.camera, props.searchFilters.eventTags, lastEndTime, newEndTime, props.events)
        }
      }
    }, 200)

    setScrollTimeout(timeout)
  }

  return (
    <div title="Scroll to view other events" style={{...styles.container, ...(props.eventsLoading && {cursor: 'wait'})}}>
      <div ref={scrollRef} onWheel={() => {props.setScrollerObj('cards')}} onScroll={handleScroll} style={styles.subContainer} >
        {getEventCards()}
      </div>
    </div>
  )
}

const mapStateToProps = state => {
  const { token } = state.auth
  const { cameras } = state.data
  const { searchFilters, startTime, endTime, eventsLoading, events, filteredEvents, scrollerObj, selectedEvent } = state.playback
  
  return {
    token,
    cameras,
    searchFilters,
    startTime,
    endTime,
    eventsLoading,
    events,
    filteredEvents,
    scrollerObj,
    selectedEvent,
  }
}

export default connect(mapStateToProps, { setStartTime, setEndTime, setScrollerObj, getPlaybackEvents })(CardsContainer);

const styles = {
  container: {
    width: '12vw',
    minWidth: '12vw',
    overflow: 'hidden',
    cursor: 'ns-resize',
  },
  subContainer: {
    height: '100%',
    width: '14vw',
    display: 'flex',
    flexDirection: 'column',
    gap: '2vh',
    overflow: 'hidden scroll',
  },
  message: {
    margin: 'auto',
    textAlign: 'center',
    padding: '0 .5vw',
  },
}